module.exports = __webpack_public_path__ + "static/media/nodata.d4c6647c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nodata.png
// module id = 693
// module chunks = 0